module.exports = __webpack_public_path__ + "static/img/event18.ede6bbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event18.png
// module id = H7te
// module chunks = 1